import {
    Autocomplete, Button,
    Dialog, DialogContent,
    DialogContentText,
    DialogTitle, FormControl, FormHelperText, Grid,
    IconButton, InputLabel, MenuItem, Select, TextField, Typography
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';

import CloseIcon from "@mui/icons-material/Close";
import { Formik } from "formik";
import React from "react";
import { injectIntl } from "react-intl";
import { Loadable } from "../../common";
import { updateProviderNPIRole } from '../../store/actions/contractProviders';
import { useDispatch } from "react-redux";
import { useGlobalStore } from "../../common";

const useStyles = makeStyles(theme => ({
    textField: {
        width: "85%"
    },
    formControlAuto: {
        width: "85%"
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500]
    },
    dropZone: {
        minHeight: 150,
        border: "none",
        backgroundColor: "#EAEAEA",
        borderRadius: "20px"
    },
    formControl: {
        marginTop: theme.spacing(2),
        width: "100%"
    }
}));

function UpdateNpiRoleDialog({
    intl,
    openPtr,
    selectedItemsIdsPtr,
    initialValues = { npiRoleId: '' },
    handleRefresh
}) {
    const pending = useGlobalStore( s => s.contractProviders.updateNPIRole.pending );
    const npiRoles = useGlobalStore( s => s.npiRoles.data );

    const dispatch = useDispatch();

    const classes = useStyles();
 
    function handleClose() {
        openPtr.set(false);
    }

    const updateNPIRoleCallback = (params) => {
        selectedItemsIdsPtr.set([])
        handleClose()
        handleRefresh()
    }

    const selectedItems = selectedItemsIdsPtr.value;
    return (
        (<Dialog maxWidth="xs" fullWidth open={openPtr.value} onClose={handleClose}>
            <DialogTitle>
                <Grid container alignItems="center">
                    <Grid item xs={10}>
                        <Typography variant="h6">Provider Role</Typography>
                    </Grid>
                    <Grid item xs={2} className="text-right">
                        <IconButton aria-label="close" onClick={handleClose} size="large">
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                {selectedItems?.length === 0 && (
                    <DialogContentText>
                        No provider Selected, please select at-least one provider to update provider role.
                    </DialogContentText>
                )}

                {selectedItems?.length > 0 && (
                    <Loadable loading={pending}>
                        <Formik
                            enableReinitialize={true}
                            initialValues={initialValues}
                            validate={values => {
                                const errors : any = {};

                                if (!values.npiRoleId) {
                                    errors.npiRoleId = intl.formatMessage({
                                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                    });
                                }

                                return errors
                            }}
                            onSubmit={(
                                values,
                                {  }
                            ) => {

                                const payload = { ids: selectedItems, npiRoleId: values?.npiRoleId}
                                dispatch(updateProviderNPIRole(payload, updateNPIRoleCallback))
                            }}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleSubmit,
                                handleBlur,
                                handleChange,
                                setFieldValue,
                            
                            }) => (
                                <form
                                    onSubmit={handleSubmit}
                                    noValidate
                                    autoComplete="off"
                                >
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <FormControl className={classes.formControl}>
                                                <InputLabel htmlFor="npiRoleId">Select Role</InputLabel>
                                                <Select
                                                    required
                                                    value={values.npiRoleId}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    name="npiRoleId"
                                                    error={Boolean(touched.npiRoleId && errors.npiRoleId)}
                                                >
                                                    {npiRoles.map(role => (
                                                        <MenuItem
                                                            key={role.id}
                                                            value={role.id}
                                                        >
                                                            {role.name}
                                                        </MenuItem>
                                                    ))}

                                                </Select>
                                                <FormHelperText error={Boolean(errors.npiRoleId)}>{errors.npiRoleId}</FormHelperText>
                                            </FormControl>
                                        </Grid>
                                        <Grid
                                            container
                                            className="justify-content-end pt-2"
                                            style={{ marginTop: "20px" }}
                                        >
                                            <Button type="button" onClick={handleClose} variant="contained" className="mr-3">
                                                Cancel
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                type="submit"
                                            >
                                                Update
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </Formik>
                    </Loadable>
                )}
            </DialogContent>
        </Dialog>)
    );
}

export default injectIntl(UpdateNpiRoleDialog);
